import { NumberValue } from '../../../utils'
import type { InvoiceFormRowLine } from '../types/invoiceForm/invoiceFormLine/invoiceFormRowLine'
import type { InvoiceFormSubtotalLine } from '../types/invoiceForm/invoiceFormLine/invoiceFormSubtotalLine'

export const sumRowLineTotals = (
  rowLines: Pick<InvoiceFormRowLine, 'totalExcludingVat' | 'totalIncludingVat'>[],
): Pick<InvoiceFormSubtotalLine, 'subtotalExcludingVat' | 'subtotalIncludingVat'> =>
  rowLines.reduce(
    (subtotal, line) => ({
      subtotalExcludingVat: new NumberValue(subtotal.subtotalExcludingVat).add(line.totalExcludingVat).getRounded(),
      subtotalIncludingVat: new NumberValue(subtotal.subtotalIncludingVat).add(line.totalIncludingVat).getRounded(),
    }),
    { subtotalExcludingVat: 0, subtotalIncludingVat: 0 },
  )
